const fonts = {
  TEXT_FONT: 'Lato',
  HEADING_FONT: 'Montserrat'
}

export default fonts;
